import React from 'react';
import { Section } from '@layout';
import { H2 } from '@heading';
import styles from './Pillars.module.scss';

export default function Pillars() {
  return (
    <Section
      maxContentWidth={1200}
      fullWidth
      isDark
    >
      <div className={styles.top}>
        <H2>
          Our <span>five pillars</span> for success
        </H2>
        <p>
          The Center’s approach focuses on early career and faculty fellows
          programs.
        </p>
      </div>

      <ol className={styles.list}>
        <li>
          We study STEAM and learn experientially by working in
          collaborative settings to solve real world problems and engage in
          activism. Our model includes research and community outreach
          “from K to gray” to promote environmental literacy. Our fellows
          grow and practice skills, prepare themselves for the future, and
          empower others.
        </li>

        <li>
          Our intergenerational interaction, in inclusive and diverse
          communities of practice, changes the entire environment of
          learning.
        </li>

        <li>
          We focus on translating values and learning into behaviors and
          practices. From early career fellows to faculty, we implement new
          practices in the classroom, the research lab, and in outreach. We
          are leaders in STEAM that respect identities, families, and
          communities.
        </li>

        <li>
          Our cohorts model diversity in higher education by including
          people at varied educational and career stages. These cohorts
          support social belonging and sharing their stories, including of
          scientific discovery, adversity, and resilience.
        </li>

        <li>
          We demonstrate that people who look like us and relate to our
          challenges make it to every educational stage and into the
          workforce. Our diverse mentors and role models show that there
          are always opportunities to lead. Leadership relies on continued
          learning, adapting practices, and working with others with
          confidence, humility, and wisdom.
        </li>
      </ol>
    </Section>
  );
}
